// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".img-lanyard{width:50px;height:50px;margin-top:8px}", ""]);
// Exports
module.exports = exports;
